   <div class="ipm-title-page-heading">
        <h1 *ngIf="!isShowTab">{{heading}}</h1>
        <ng-container  *ngIf="isShowTab">
          <ipm-button-toggle [selectedValue]="currentSelectedTab" [textArray]="tabList" (onChangeToggleButtonEvent)="handleTabChangeEvent($event)"></ipm-button-toggle>
        </ng-container>
        <div class="sort-section desktop-sort">
            <div class="status-filter" *ngIf="isShowingSorts">
                <p-dropdown inputId="statusFIlter" [options]="statusListData"
                    [(ngModel)]="selectedStatusData"
                    optionLabel="label"
                    aria-label="Status"
                    [ngModelOptions]="{standalone: false}" placeholder="Status"
                    [className]="'ipm-dropdown'"
                    (ngModelChange)="handleStatusChange($event)">
                </p-dropdown>
            </div>
            <div class="ipm-search-section" *ngIf="isShowingSearch">
               <div class="search-bar">
                  <div class="search-bar-input">
                      <i class="fa fa-search ml-3" aria-hidden="true"></i>
                      <input type="search" id="my-beat-serach" class="form-control search-input" placeholder="Search {{serachText}}" #search   
                        (search)="onChangeSearchInput($event)"
                        (input)="onChangeSearchInput($event)">
                  </div>
              </div>
            </div>
        </div>
    </div>